// src/components/HeroSection.js
import React from "react";
import styles from "../styles/HeroSection.module.css";
import logo from "../assets/app_logo.jpg"; // 큰 로고 이미지 경로

function HeroSection() {
  return (
    <div className={styles.heroContainer}>
      <img src={logo} alt="회사 로고" className={styles.companyLogo} />
      <h1 className={styles.companyName}>이룸그린테크</h1>
      <p className={styles.companySlogan}>
        자원 재활용과 환경 보호를 실현합니다.
      </p>
    </div>
  );
}

export default HeroSection;
